import React from "react";
import PropTypes from "prop-types";

import { CreateContainer } from "./ContainerCreate";
import { getArtistUserFavorites } from "~/api/getChimneyProfile";
import Spinner from "react-bootstrap/Spinner";

class ArtistFavoritesContainer extends React.Component {
  componentDidMount() {
    const { dir } = this.props;
    this.props.request(dir);
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const artists = (data && data.data && data.data.artists) || [];
    if (loading) {
      return <Spinner animation="border" variant="secondary" />;
    }
    return render({ artists, loading, failure });
  };
}

ArtistFavoritesContainer.propTypes = {
  dir: PropTypes.string.isRequired,
};

export default CreateContainer(getArtistUserFavorites, ArtistFavoritesContainer);
